import { initialize, ServerResponse, global } from "./utils";

const request = (url, options = {}) => new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest() 
    const {
        method,
        cache,
        credentials,
        headers,
        body,
        responseType,
        timeout,
        onupload,
        ondownload
    } = initialize(options)
    
    xhr.open(method, url, true)

    xhr.withCredentials = credentials.trim() === "include"

    xhr.timeout = timeout

    xhr.responseType = responseType

    if(cache !== "default")
        xhr.setRequestHeader("Cache-Control", cache)

    Object.keys(headers).forEach((key) => {
        xhr.setRequestHeader(key, headers[key])
    })
    
    if(xhr.upload)
        xhr.upload.onprogress = onupload

    xhr.onprogress = ondownload

    xhr.onload = () => resolve(new ServerResponse(xhr))

    xhr.onabort = () => reject(new DOMException('Aborted', 'AbortError'))

    xhr.onerror = xhr.ontimeout = () => reject(new TypeError('Network request failed'))

    xhr.send(body)
})

request.global = global

export default request